export default "<div class=\"footer-wrapper\">\n    <p>Copyright arathykumar.com <span class=\"material-icons\">copyright</span> 2025</p>\n</div>\n"